//axios api
import api from "@/lib/Api";

export const getCommissions = async () => {
  try {
    const queryRoute = `/commission`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const updateToPendingCalculate = async (body) => {
  try {
    const queryRoute = `/commission/pendingCalculate`;

    const fetchRes = api.axios.patch(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
export const getSumOfCommissionRecord = async (product_id, date) => {
  try {
    const queryRoute = `/commission/sumOfCommission?product_id=${product_id}&date=${date}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
export const getSettings = async () => {
  try {
    const queryRoute = `/commission/settings`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getSettingById = async (id) => {
  try {
    const queryRoute = `/commission/settings/${id}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const updateSetting = async (id, body) => {
  try {
    const queryRoute = `/commission/settings/${id}`;

    const fetchRes = api.axios.put(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const createSetting = async (body) => {
  try {
    const queryRoute = `/commission/settings`;

    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const calculation = async (body) => {
  try {
    const queryRoute = `/commission/calculation`;

    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const download = async (body) => {
  try {
    const queryRoute = `/commission/download`;

    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const approve = async (body) => {
  try {
    const queryRoute = `/commission/approve`;

    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
export const importDirectSales = async (body) => {
  try {
    const queryRoute = `/commission/directSales`;

    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
